import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Input, Row, Table } from "reactstrap";
import { fetchData, _fetchApi, get_country_classification } from "../api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoadingComponent } from ".";
import Gray from "../Gray";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ExcelDownload } from "./IndicatorBreakdown";

export default function CountriesByIndicator({}) {
  const [data, setData] = useState([]);
  const [ppp, setppp] = useState([]);
  const [indicatorWorld, setIndicatorWorld] = useState([]);
  const [indicatorAfrc, setIndicatorAfrc] = useState([]);
  const [yearList, setYearList] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const indicator = searchParams.get("indicator");
  const country = searchParams.get("country");
  const year_from = searchParams.get("year_from");
  const year_to = searchParams.get("year_to");
  const region = searchParams.get("region");
  const type_of_data = searchParams.get("type_of_data");
  const new_indicator = searchParams.get("new_indicator");
  const display = true;

  const [formattedData, setFormattedData] = useState([]);
  const [form, setForm] = useState({
    year_from,
    year_to,
    new_year_from: year_from,
    new_year_to: year_to,
    indicator,
    country,
    region,
    type_of_data,
    new_indicator,
    data_source: "IMF",
    uemoa: "NON-UEMOA",
    uemoa2: "NON-UEMOA",
  });
  const [grouping, setGrouping] = useState([]);
  const getQueryParams = (key, value) => {
    console.log(key);
    setForm((p) => ({
      ...p,
      [key]: value,
    }));
  };

  

  useEffect(() => {
    get_country_classification(setGrouping);
  }, []);

  const handleChange = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  React.useEffect(() => {
    fetchData({
      query_type: "get_indicators",
      type_of_data: "World Economic Outlook",
      data_source: form.data_source,
    })
      .then((d) => {
        if (d && d.results) {
          setIndicatorWorld([
            // 'Regional Indicator',
            ...d.results.map((a) => a.indicator),
          ]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [form.data_source]);

  React.useEffect(() => {
    fetchData({
      query_type: "get_indicators",
      type_of_data: "Sub-Saharan Africa Regional Economic Outlook?(AFRREO)",
      data_source: form.data_source,
    })
      .then((d) => {
        if (d && d.results) {
          setIndicatorAfrc([...d.results.map((a) => a.indicator)]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [form.data_source]);

  // const get_by_Average = useCallback(() => {
  //   _fetchApi(
  //     `/get_by_indicator?query_type=new_average&year_from=${year_from}&year_to=${year_to}&indicator=${indicator}`,
  //     (d) => {
  //       // let element = "";
  //       // for (let index = 0; index < ppp.length; index++) {
  //       //   element += ppp[index].ppp;
  //       // }
  //       setData(d.results);
  //       // console.log(element, "LLLL");
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }, [year_from, year_to, indicator]);

  // useEffect(() => {
  //   get_by_ppp();
  //   get_by_Average();
  // }, [get_by_ppp, get_by_Average]);

  useEffect(() => {
    setLoading(true);
    _fetchApi(
      `/countrywise?query_type=&year_from=${form.year_from}&year_to=${form.year_to}&new_indicator=${form.new_indicator}&indicator=${form.indicator}&new_year_from=${form.new_year_from}&new_year_to=${form.new_year_to}&type_of_data=Sub-Saharan Africa Regional Economic Outlook?(AFRREO)&data_source=${form.data_source}&uemoa=${form.uemoa}`,
      (d) => {
        setLoading(false);
        // let element = "";
        // for (let index = 0; index < ppp.length; index++) {
        //   element += ppp[index].ppp;
        // }
        setData(d.results);
        let formatted = [];
        d.results.forEach((a) => {
          formatted.push({
            country: a.country,
            Ratio: a.ratio,
            Average: a.average,
            Value: a.amt,
            "Weighted Average": a["multiply"],
          });
        });
        setFormattedData(formatted);
        // console.log(element, "LLLL");
      },
      (err) => {
        setLoading(false);
        console.log(err);
      }
    );
  }, [
    form.year_from,
    form.year_to,
    form.indicator,
    form.new_indicator,
    form.new_year_from,
    form.new_year_to,
    form.data_source,
    form.uemoa,
  ]);

  // const newArr = [];
  // data.forEach((i) => {
  //   const select = ppp && ppp.filter((o) => i.country === o.country);

  //   newArr.push({ ...i, ppp: select[0]?.ppp });
  // });

  // const totalP = newArr.reduce((a, b) => a + b.pct, 0);
  // const totalAvg = newArr.reduce((a, b) => a + parseFloat(b.pct * b.ppp), 0);

  useEffect(() => {
    fetchData({
      query_type: "get_years",
    })
      .then((d) => {
        if (d && d.results && d.results.length) {
          // console.log(d.results[d.results.length - 1].year, 'from')
          // console.log(d.results[0].year, 'to')
          setYearList(d.results.map((a) => a.year));
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const sumWeightedAvg = data && data.reduce((a, b) => a + b.multiply, 0);

  return (
    <>
      <div className="row align-items-center">
        <Button
          size="sm"
          onClick={() => navigate(-1)}
          color="warning"
          className="col-1"
        >
          Go back
        </Button>
        <Button
          className="m-2 col-2"
          color={display ? "primary" : "secondary"}
          onClick={() => navigate("/annual-change")}
        >
          Annual Percentage Change
        </Button>

        <div className="col-2 offset-5">
          <ExcelDownload raw={formattedData} fileName={`Weighted Average `} />
        </div>

        {/* <Input
            type="select"
            value={form.uemoa}
            name="uemoa"
            onChange={({ target: { value } }) => {
              setForm(p => ({ ...p, uemoa: value}))
              // getQueryParams('uemoa', value)
            }}
          >
            {['NON-UEMOA', 'UEMOA'].map((indicator, id) => (
              <option key={id} value={indicator}>
                {indicator}
              </option>
            ))}
          </Input>
        <div className="col-1" onChange={({target:{value}}) => setForm(p => ({ ...p, data_source: value}))}>
          <Input type="select" >
          <option value={'IMF'}>IMF</option>
            <option value={'World Bank'}>World Bank</option>
          </Input>
        </div> */}
      </div>
      <Card className="p-1 mt-1">
        <Row className=" ">
          <Col md={6} className="pe-1">
            <Card className="p-1 border border-dark">
              <Row className="mb-3">
                <Col md={6} className="m-0 pe-1">
                  <label>Select Regional Indicator</label>
                  <Input
                    type="select"
                    value={form.indicator}
                    name="indicator"
                    onChange={({ target: { value } }) => {
                      getQueryParams("indicator", value);
                    }}
                  >
                    <option>--select--</option>
                    {indicatorAfrc.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>

                <Col md={6} className="m-0 ps-1">
                  <label>Select Country Classification</label>
                  <Input
                    type="select"
                    value={form.uemoa}
                    name="uemoa"
                    onChange={({ target: { value } }) => {
                      getQueryParams("uemoa", value);
                    }}
                  >
                    <option>--select--</option>
                    {grouping.map((indicator, id) => (
                      <option key={id} value={indicator.grouping}>
                        {indicator.grouping}
                      </option>
                    ))}

                    {/* <option>--select--</option>
                    {["UEMOA", "NON-UEMOA"].map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))} */}
                  </Input>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6} className="m-0 pe-1">
                  <label className="">From</label>
                  <Input
                    type="select"
                    value={form.year_from}
                    name="year_from"
                    onChange={handleChange}
                  >
                    {yearList.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={6} className="m-0 ps-1">
                  <label className="">To</label>
                  <Input
                    type="select"
                    value={form.year_to}
                    name="year_to"
                    onChange={handleChange}
                  >
                    {yearList.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col md={6} className="ps-1">
            <Card className="p-1 border border-dark">
              <Row className=" ">
                <Col md={6} className="pe-1">
                  <label>Select World Indicator</label>
                  <Input
                    type="select"
                    value={form.new_indicator}
                    name="new_indicator"
                    onChange={({ target: { value } }) =>
                      getQueryParams("new_indicator", value)
                    }
                  >
                    <option>--select--</option>
                    {indicatorWorld.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={6} className="m-0 ps-1">
                  <label>UEMOA</label>
                  <Input
                    type="select"
                    value={form.uemoa2}
                    name="uemoa2"
                    onChange={({ target: { value } }) => {
                      getQueryParams("uemoa2", value);
                    }}
                  >
                    <option>--select--</option>
                    {["UEMOA", "NON-UEMOA"].map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
              {/* {JSON.stringify({indicator, new_indicator})} */}
              <Row className="mb-3">
                <Col md={6} className="m-0 pe-1">
                  <label className="">From</label>

                  <Input
                    type="select"
                    value={form.new_year_from}
                    name="new_year_from"
                    onChange={handleChange}
                  >
                    {yearList.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={6} className="m-0 ps-1">
                  <label className="">To</label>

                  <Input
                    type="select"
                    value={form.new_year_to}
                    name="new_year_to"
                    onChange={handleChange}
                  >
                    {yearList.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <div
          style={{ height: "80vh", overflow: "auto", marginTop: 5 }}
          className="card card-body  border border-dark"
        >
          {loading && <LoadingComponent />}

          {/* {JSON.stringify(form)} */}
          <Table bordered striped style={{ marginTop: 10 }}>
            <thead>
              <tr>
                <th className="text-center">Country</th>
                <th className="text-center">GDP</th>
                <th className="text-center">
                  Ratio
                  {/* Percentage */}
                </th>
                <th className="text-center">
                  Average
                  {/* PPP */}
                </th>
                <th className="text-center">Weighted Avg.</th>
              </tr>
            </thead>
            <tbody>
              {data.map((d, i) => (
                <tr key={i}>
                  <td style={{ cursor: "pointer" }}>{d.country}</td>
                  <td className="text-end">
                    {((d.amt * 100) / 100).toFixed(4)}
                  </td>
                  {/* <td>{form.country.includes('Regional Outlook') ? d.country : d.indicator}</td> */}
                  <td className="text-end">
                    {((d.ratio * 100) / 100).toFixed(4)}
                    {/* {(((d.pct * 100) / 100).toFixed(4))} */}
                  </td>
                  <td className="text-end">
                    {((d.average * 100) / 100).toFixed(4)}
                    {/* {(((d.ppp * 100) / 100).toFixed(4))} */}
                  </td>
                  <td className="text-end">
                    {((d.multiply * 100) / 100).toFixed(4)}
                    {/* {((d.pct * d.ppp * 100) / 100).toFixed(4)} */}
                  </td>
                </tr>
              ))}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="text-end">{sumWeightedAvg}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Card>

      <Card>
        <BarChart
          width={1000}
          height={380}
          data={formattedData}
          // data={data}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="country" angle={-45} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Weighted Average" fill="#8884d8" />
          {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
        </BarChart>
      </Card>
    </>
  );
}
